import { TransportationTypeIcon } from '@/components/icons/TransportationTypeIcon';
import { Badge } from '@/components/primitives/Badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/primitives/Tooltip';
import { Typography } from '@/components/primitives/Typography';
import { TransText } from '@/i18n/trans/text';
import type { LegDTO } from '@/types/dto/agent';
import { getPtModeIconName } from '@/utils/icon';
import type { FC } from 'react';

interface TransportBadgeProps {
  leg: LegDTO;
  refundedLike: boolean;
}

const TransportBadge: FC<TransportBadgeProps> = ({ leg, refundedLike }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant={refundedLike ? 'disabled' : 'light'}
            className="rounded-sm"
          >
            <TransportationTypeIcon ptMode={leg.ptMode} />
            <Typography variant="body2-bold">{leg.lineNumber}</Typography>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <Typography variant="body2">
            <TransText i18nKey={getPtModeIconName(leg.ptMode)} />
          </Typography>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default TransportBadge;
